export default __webpack_public_path__ + "static/media/Staff3.2496848a.JPG";